import { memo } from 'react'
import {
  Award,
  Main,
  Year,
  Name,
  Points,
  Footer,
  MedalType,
  Trophy,
} from './_styles'

const getRewardNameByType = (rewards, type) => {
  const reward = (rewards || []).find(v => v?.rewardType?.masterName === type)
  return reward?.shortName
}

const AwardItem = ({ award }) => {
  const year = award?.year
  const name = award?.award?.masterNameShort
  const points =
    award?.maxScore !== award?.minScore
      ? `${award?.minScore} - ${award?.maxScore}`
      : award?.maxScore
  const medal = getRewardNameByType(award?.rewards, 'Medal')
  const trophy = getRewardNameByType(award?.rewards, 'Trophy')

  return (
    <Award>
      <Main>
        <Year>{year}</Year>
        <Name>{name} </Name>
        <Points>{points}</Points>
      </Main>
      <Footer>
        <MedalType>
          {medal}
          {medal && trophy && ','}
        </MedalType>

        <Trophy>{trophy}</Trophy>
      </Footer>
    </Award>
  )
}

export default memo(AwardItem)
